import styled, { StyledProps } from 'styled-components/macro';
import { CSSProperties } from 'react';

export type IconStylesProps = StyledProps<{
  size?: number | string;
  className?: string;
  onClick?: (props?: any) => void;
  style?: CSSProperties;
  fill?: string;
  transform?: string;
  hoverCursor?: string;
}>;

export const IconStyled = styled.svg<IconStylesProps>`
  width: ${(props) => props.size};
  height: ${(props) => props.size};

  &:hover {
    cursor: ${(props) => props.hoverCursor || 'pointer'};
  }
`;
